module.exports = __webpack_public_path__ + "722184e9c8816ea382a05b00df68c68e.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-2.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-2.jpg
// module chunks = 40